// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import type { State } from '../../utils.tsx';

export const removeDocumentTitle =
	(titleSymbol: symbol): Action<State> =>
	({ setState, getState }) => {
		const { contextArray } = getState();
		setState({
			contextArray: contextArray.filter(
				(titleContext) => typeof titleContext === 'object' && titleContext.symbol !== titleSymbol,
			),
		});
	};
